import styles from '../widgets/header-search-bar.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinusCircle } from '@fortawesome/pro-light-svg-icons'
import PlusCircle from '../svg/PlusCircle.svg'
import Popup from '../popup'
import React, { useState } from 'react'

const SingleGuestsPopup = ({ popupState, guests, handleChange }) => {
  const [adults, setAdults] = useState(guests)
  return (
    <Popup
      onClose={() => {
        popupState(adults)
      }}
      style={{
        left: '50%',
        transform: 'translateX(-50%)',
        width: '200%',
      }}
      position={'center'}
    >
      <ul>
        <li className={`flex flex-row ${styles.guestsPopupOption}`}>
          <h4 style={{ fontSize: 22 }} className=" flex-grow">
            Guest{adults > 1 ? 's' : ''}
          </h4>
          <div className="flex flex-row justify-end items-center">
            <span
              className={styles.addGuests}
              onClick={() => {
                if (adults > 0) {
                  setAdults(adults - 1)
                  handleChange(adults - 1)
                } else {
                  setAdults(0)
                  handleChange(0)
                }
              }}
            >
              <FontAwesomeIcon icon={faMinusCircle} />
            </span>
            <h5 className="mx-4 text-2xl">{adults}</h5>
            <span
              style={{ marginLeft: 0 }}
              className={styles.addGuests}
              onClick={() => {
                setAdults(adults + 1)
                handleChange(adults + 1)
              }}
            >
              <PlusCircle />
            </span>
          </div>
        </li>
      </ul>
    </Popup>
  )
}
export default SingleGuestsPopup
